import CreateTemplateCategoryContainer from "./CreateTemplateCategoryContainer";
export default CreateTemplateCategoryContainer;
